$.keyCode = Object.freeze({
    backspace : 8,
    tab       : 9,
    enter    : 13,
    return    : 13,
    shift     : 16,
    ctrl      : 17,
    alt       : 18,
    capsLock  : 20,
    escape    : 27,
    space     : 32,
    pageUp    : 33,
    pageDown  : 34,
    end       : 35,
    home      : 36,
    left      : 37,
    up        : 38,
    right     : 39,
    down      : 40,
    meta      : 91,
    metaLeft  : 91,
    metaRight : 93
});

$.key = Object.freeze({
    backspace : 'Backspace',
    tab       : 'Tab',
    enter    : 'Enter',
    return    : 'Enter',
    shift     : 'Shift',
    ctrl      : 'Control',
    alt       : 'Alt',
    capsLock  : 'CapsLock',
    escape    : 'Escape',
    space     : ' ',
    pageUp    : 'PageUp',
    pageDown  : 'PageDown',
    end       : 'End',
    home      : 'Home',
    left      : 'ArrowLeft',
    up        : 'ArrowUp',
    right     : 'ArrowRight',
    down      : 'ArrowDown',
    meta      : 'Meta',
    metaLeft  : 'Meta',
    metaRight : 'Meta'
});
